{
  "de": {
    "aiFeedback": {
      "confirm": {
        "deleteFeedback": {
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Das Feedback wird mit allen dazugehörigen Ergebnissen gelöscht.",
          "title": "Feedback löschen?"
        },
        "deleteResult": {
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Das Ergebnis wird mit dem dazugehörigen Feedback dauerhaft gelöscht.",
          "title": "Ergebnis löschen?"
        }
      },
      "criteria": {
        "contentAccuracy": "Das Thema wird in einer der Fragestellung angemessenen Art entfaltet und beinhaltet inhaltlich korrekte Zahlen, Daten und Fakten über das Thema.",
        "spellingAndGrammar": "Die Rechtschreibung, Wortbildung und der Satzbau sind grammatisch korrekt. Inhaltswörter, Funktionswörter, komplexe Ausdrücke und Fachtermini werden treffend verwendet.",
        "structureAndOrganization": "Der Text lässt eine dem Thema angemessene Gesamtidee erkennen, ist sinnvoll aufgebaut und lässt eine innere/äußere Gliederung erkennen, zum Beispiel durch Abschnitte."
      },
      "deprecationAlert": {
        "title": "Dieses Tool ist standardmäßig ausgeblendet",
        "description": "Es kann auf Wunsch auf Schulebene freigeschaltet werden.",
        "learnMoreLink": "Mehr erfahren"
      },
      "unlockedAlert": {
        "title": "Dieses Tool ist für deine Schule freigeschaltet",
        "description": "Es wird nicht weiterentwickelt, bleibt für deine Schule aber nutzbar.",
        "learnMoreLink": "Mehr erfahren"
      },
      "defaults": {
        "name": "Neue Korrektur"
      },
      "emptyState": {
        "heading": "Keine Korrekturen vorhanden",
        "text": "Erstelle eine neue Korrektur, indem du den Originaltext einfügst und die Kriterien festlegst."
      },
      "flash": {
        "feedbackResultUpdated": "Feedback aktualisiert",
        "feedbackUpdated": "Kriterien aktualisiert",
        "textExtractionSuccess": "Textextraktion erfolgreich"
      },
      "headings": {
        "feedback": "Korrekturvorschlag",
        "form": "Kriterien festlegen",
        "goodToKnow": "Gut zu wissen",
        "input": "Originaltext",
        "text": "Text eingeben"
      },
      "hints": {
        "dropFileImage": "Bild mit Textinhalten einfach reinziehen oder",
        "dropFilePdf": "PDF hier reinziehen oder",
        "experimental": "Das Korrekturhilfe Tool erstellt KI-generierte <strong>Vorschläge für eine Vorkorrektur</strong> von Schüler*innenleistungen. Um die Vorschläge verantwortungsvoll zu interpretieren und zu nutzen, müssen die empfohlenen <strong>Rahmenbedingungen und Einschränkungen der KI</strong> unbedingt zur Kenntnis genommen und beachtet werden. <a href='https://app.fobizz.com/de/help/articles/249-korrekturhilfe-tool-ki' target='_blank'>Mehr erfahren</a>",
        "fileLimit": "max {size}MB, {types}",
        "imageRecognitionInProgress": "Bilderkennung läuft...",
        "pdfRecognitionInProgress": "Textextraktion läuft..."
      },
      "info": {
        "result": {
          "heading": "Gut zu wissen:",
          "text": "Die Antworten der KI sind als <strong>Vorschläge</strong> zu verstehen.\nSie können niemals eine fundierte didaktische Bewertung von\nSchüler*innenleistungen ersetzen."
        }
      },
      "infoMessages": {
        "criteria": "Lege Kriterien fest, auf deren Grundlage die KI Feedback geben soll. Je genauer du die Kriterien formulierst, desto präziser ist das Feedback."
      },
      "labels": {
        "addCriteria": "Kriterium hinzufügen",
        "assignment": "Aufgabenstellung",
        "criteria": "Bewertungskriterien",
        "input": "Originaltext",
        "inputMethod": "Eingabemethode",
        "name": "Kürzel (kein Klarname), z.B. Jahrgang plus Nummer der Klassenliste",
        "solution": "Erwartungshorizont oder Musterlösung"
      },
      "links": {
        "evaluateText": "Text korrigieren",
        "new": "Neue Korrektur",
        "pastAssessments": "Vergangene Korrekturen",
        "useFile": "Text aus Bild verwenden",
        "usePdf": "Text aus PDF verwenden",
        "useText": "Originaltext einfügen"
      },
      "modals": {
        "confirm": {
          "helpLink": "https://app.fobizz.com/de/help/articles/249-korrekturhilfe-tool-ki",
          "text": "Das Korrekturhilfe Tool erstellt KI-generierte <strong>Vorschläge für eine Vorkorrektur</strong> von Schüler*innenleistungen. Um die Vorschläge verantwortungsvoll zu interpretieren und zu nutzen, müssen die empfohlenen <strong>Rahmenbedingungen und Einschränkungen der KI</strong> unbedingt zur Kenntnis genommen und beachtet werden.",
          "title": "Hinweise zur Nutzung des Korrekturhilfe Tools"
        }
      },
      "paragraphs": {
        "create": "Spare wertvolle Zeit beim Korrigieren durch KI-gestützte Fehlerkorrektur und Bewertungsvorschläge.",
        "goodToKnow": "Die Antworten der KI sind als <strong>Vorschläge</strong> zu verstehen. Sie können niemals eine fundierte didaktische Bewertung von Schüler*innenleistungen ersetzen."
      },
      "placeholders": {
        "assignment": "Schreibe einen kurzen Aufsatz über die wichtigsten Ursachen und historischen Begebenheiten der französischen Revolution.",
        "input": "Text hier einfügen...",
        "name": "4c-17",
        "solution": "Musterlösung:\nFranzösische Revolution Die F. R. von 1789 gilt als einer der wichtigsten politisch-sozialen Wendepunkte in der europäischen Geschichte. Sie beseitigte die absolutistische Herrschaft und die Vorrechte von Adel und Kirche und setzte an deren Stelle den bürgerlichen Stand. Ursache für die F. R. waren tief greifende soziale und wirtschaftliche Missstände (Hungersnöte, Zahlungsunfähigkeit des Staates Tragendes Element der F. R. war die französische Nationalversammlung, die 1789 die Erklärung der Menschen- und Bürgerrechte (Déclaration des droits de l’homme et du citoyen) verabschiedete. 1793 wurden die Ziele der F. R. in der Forderung nach Freiheit, Gleichheit, Brüderlichkeit (Liberté, Égalité, Fraternité) schlagwortartig zusammengefasst und zur Parole, die weit über FRA hinausgetragen wurde und in nahezu allen europäischen Staaten Auswirkungen hatte. Das Verbot der Parole in den preußischen Rheinprovinzen wirkt bis heute im bürgerlichen Karneval und der magischen Zahl ELF (Égalité, Liberté, Fraternité), die nicht verboten werden konnte, nach: Warum sollte sonst der Aufstand der Narren (= Bürger) immer am 11.11. um 11 Uhr 11 beginnen?\nQuelle: Schubert, Klaus/Martina Klein: Das Politiklexikon. 7., aktual. u. erw. Aufl. Bonn: Dietz 2020. Lizenzausgabe Bonn: Bundeszentrale für politische Bildung."
      },
      "sampleText": "Yo, Diggi! Die französishe Revolution war so 'ne krasse Zeit, die von 1789 bis 1799 ging. Die Leute hatten die Schnauze voll von den Ahdligen und dem König, die nur am Chillen waren, während das Volk hungerte. Also haben sie gesagt: \"Jetzt reicht's, Alter!\" und haben den König und die Adligen abgesägt. Dass war das Ende der Monarchie und der Start für die erste Republick in Frankreich. Aber es war nicht alles cool, gab auch viel Blutvergißen, vorallem während der sogenannten \"Reign of Terror\". Aber am Ende des Tages, hat diese Revolution die Welt verändert und Ideen wie Freiheit, Gleichheit und Brüderlichkeit verbreitet. Total abgefahren, oder?"
    }
  }
}
